import { render, staticRenderFns } from "./eventsArchiveModal.vue?vue&type=template&id=22ee76f1&scoped=true&lang=pug&"
import script from "./eventsArchiveModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./eventsArchiveModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./eventsArchiveModal.vue?vue&type=style&index=0&id=22ee76f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ee76f1",
  null
  
)

export default component.exports